import React from 'react';
import { Box, Typography } from '@mui/material';
import { ActionableItem } from '../../types';

const Field: React.FC<{ label: string; full?: boolean; children: React.ReactNode }> = ({ label, full, children }) => (
    <Box sx={{ minWidth: 0, gridColumn: full ? '1 / -1' : undefined }}>
        <Typography sx={{ fontSize: '0.62rem', fontWeight: 800, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#8A8078' }}>{label}</Typography>
        <Typography sx={{ fontSize: '0.85rem', fontWeight: 600, wordBreak: full ? 'break-word' : 'normal' }}>{children}</Typography>
    </Box>
);

const istFormatter = new Intl.DateTimeFormat('en-IN', { timeZone: 'Asia/Kolkata', dateStyle: 'medium', timeStyle: 'short' });

const formatRequestedAt = (value: unknown): string => {
    if (!value) return '—';
    const d = new Date(value as string);
    return Number.isNaN(d.getTime()) ? '—' : istFormatter.format(d);
};

// Body of a "pending_access_request" card: a clean field list (Name / Email / Requested / Reason).
// We deliberately never surface requestId or the raw Mongo _id — those stay in the payload only so
// verifyDone can resolve the request.
const AccessRequestBody: React.FC<{ item: ActionableItem }> = ({ item }) => {
    const p = item.payload || {};

    return (
        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: 1 }}>
            <Field label="Name">{p.name ? String(p.name) : '—'}</Field>
            <Field label="Email">{p.email ? String(p.email) : '—'}</Field>
            <Field label="Requested">{formatRequestedAt(p.requestedAt)}</Field>
            <Field label="Reason" full>{p.reason ? String(p.reason) : '—'}</Field>
        </Box>
    );
};

export default AccessRequestBody;
